import Api from '@/services/Api'
import LogService from "@/services/LogService";

let isInProcessOfRefreshingToken = false;
let tokenRefreshRequest;

export default {
  GetAccessToken(username, password) {
    return Api().post('/auth/accessToken/', JSON.stringify({username, password}))
      .then(response => {
        localStorage.setItem('token', response.data.result.accessToken);
        localStorage.setItem('refresh_token', response.data.result.refreshToken);
        return response.data.result.accessToken;
      });
  },
  RefreshToken(refreshToken) {
    if (!isInProcessOfRefreshingToken) {
      isInProcessOfRefreshingToken = true;
      tokenRefreshRequest = Api().post('/auth/refreshToken/', JSON.stringify({refreshToken}))
        .then(response => {
          localStorage.setItem('token', response.data.result.accessToken);
          localStorage.setItem('refresh_token', response.data.result.refreshToken);
          isInProcessOfRefreshingToken = false;
          return response.data.result.accessToken;
        });
    }
    return tokenRefreshRequest;
  },
  IsTokenValid(token) {
    try {
      return LogService.parseJwt(token).exp > (Date.now() / 1000);
    }
    catch {
      return false;
    }
  },
  ResetPassword(email) {
    return Api().post('/auth/password/reset', JSON.stringify({userName: email}));
  }
}
